import { useEffect, useState } from "react";
import { Camera, X } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/constants";
import { cn } from "@/lib/utils";

const cache = new Map();
export function AuthImage({ fileId, className, alt }) {
  const [src, setSrc] = useState(cache.get(fileId));
  useEffect(() => {
    if (!fileId || cache.has(fileId)) return;
    let alive = true;
    api.get(`/files/${fileId}`, { responseType: "blob" }).then((r) => { const u = URL.createObjectURL(r.data); cache.set(fileId, u); if (alive) setSrc(u); }).catch(() => {});
    return () => { alive = false; };
  }, [fileId]);
  if (!src) return <div className={cn("flex items-center justify-center bg-muted text-muted-foreground", className)}><Camera className="h-4 w-4 animate-pulse" /></div>;
  return <img src={src} alt={alt || ""} className={cn("object-cover", className)} />;
}

export function PhotoGallery({ student, compact }) {
  const [view, setView] = useState(null);
  const photos = (student.items || []).filter((i) => i.photo?.file_id);
  const needed = (student.items || []).filter((i) => i.require_photo && !i.photo);
  if (!photos.length && !needed.length) return null;
  return (
    <div className={cn("rounded-xl border bg-card p-3", compact && "p-2.5")} data-testid={`photo-gallery-${student.name}`}>
      <div className="mb-2 flex items-center justify-between text-xs"><span className="data-label flex items-center gap-1"><Camera className="h-3.5 w-3.5" />Foto bukti · {photos.length}</span>{needed.length > 0 && <span className="rounded bg-amber-500/15 px-1.5 py-0.5 text-[10px] text-amber-700 dark:text-amber-300" data-testid={`photo-missing-${student.name}`}>{needed.length} wajib foto belum ada</span>}</div>
      <div className="grid grid-cols-3 gap-2">
        {photos.map((i) => (
          <button key={i.key} type="button" onClick={() => setView(i)} className="group relative aspect-square overflow-hidden rounded-lg border active:scale-[0.98]" data-testid={`photo-thumb-${i.key}`}>
            <AuthImage fileId={i.photo.file_id} className="h-full w-full" alt={i.label} />
            <div className="absolute inset-x-0 bottom-0 truncate bg-black/60 px-1.5 py-0.5 text-left text-[10px] text-white">{i.label}</div>
          </button>
        ))}
        {needed.map((i) => <div key={i.key} className="flex aspect-square flex-col items-center justify-center gap-1 rounded-lg border border-dashed border-amber-500/50 p-1 text-center text-[10px] text-amber-700 dark:text-amber-300" data-testid={`photo-needed-${i.key}`}><Camera className="h-4 w-4" /><span className="line-clamp-2">{i.label}</span></div>)}
      </div>
      {view && (
        <div className="fixed inset-0 z-50 flex flex-col bg-black/95 text-white" onClick={() => setView(null)} data-testid="photo-viewer">
          <div className="flex items-center justify-between p-3 text-sm"><div><div className="font-semibold">{view.label}</div><div className="text-[11px] text-slate-300">{student.name} · {view.by} · {fmtDateTime(view.at)}</div></div><button className="rounded-md p-1.5 hover:bg-white/10" data-testid="photo-viewer-close"><X className="h-5 w-5" /></button></div>
          <div className="flex flex-1 items-center justify-center p-3"><AuthImage fileId={view.photo.file_id} className="max-h-full max-w-full rounded-md !object-contain" alt={view.label} /></div>
        </div>
      )}
    </div>
  );
}
